import { useDisclose } from 'basic-react-hooks';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setPublicUserLogin } from 'redux/reducers/publicUser';
import { verifyPublicUserAccessToken } from 'rest_client/publicUserClient';
import Constants from 'utils/Constants';
import { readCookie } from 'utils/cookies';

const useFetchPublicUserInfo = (init = true) => {
  const dispatch = useDispatch();
  const {
    isOpen: isLoading,
    onOpen: onLoading,
    onClose: onStopLoading,
  } = useDisclose();
  const getUserInfo = async () => {
    try {
      onLoading();
      let access_token = readCookie(Constants.PUBLIC_USER_ACCESS_TOKEN);
      if (!access_token) {
        return;
      }
      const response = await verifyPublicUserAccessToken(
        { accessToken: access_token },
        dispatch,
      );
      dispatch(
        setPublicUserLogin({ ...response.data, accessToken: access_token }),
      );
    } catch (error) {
      console.log(error);
    }
    onStopLoading();
  };
  useEffect(() => {
    if (init) {
      getUserInfo();
    }
  }, [init]);

  return { getUserInfo, isLoading };
};

export default useFetchPublicUserInfo;
